module.exports = __webpack_public_path__ + "8d366135a75de8eed22ebff884e2ca22.MP3";